export function cityLabel(hotel) {
  if (Number(hotel.cityId) === 279) return "Makkah";
  if (Number(hotel.cityId) === 278) return "Madinah";
  return hotel.cityName || "";
}

export function hotelBadge(hotel) {
  return hotel.status || cityLabel(hotel) || "Unknown";
}

export function hotelPrice(hotel) {
  const value = hotel?.netPrice ?? hotel?.price ?? hotel?.approxPrice ?? hotel?.startingPrice ?? hotel?.minPrice ?? hotel?.rate;
  if (value == null || value === "") return null;
  const amount = Number(String(value).replace(/,/g, ""));
  return Number.isNaN(amount) ? null : amount;
}

export function parseHotelStars(hotel) {
  const match = String(hotel?.stars ?? "").match(/[\d.]+/);
  if (!match) return null;
  const stars = Number(match[0]);
  return Number.isFinite(stars) ? stars : null;
}

export function hotelStarsLabel(hotel) {
  const stars = parseHotelStars(hotel);
  if (stars == null) return hotel?.stars || "Not set";
  return `${stars} ${stars === 1 ? "star" : "stars"}`;
}

export function parseHotelDistance(hotel) {
  const raw = hotel?.distance ?? hotel?.formattedDistance ?? "";
  const match = String(raw).replace(/,/g, "").match(/[\d.]+/);
  if (!match) return null;
  const distance = Number(match[0]);
  return Number.isFinite(distance) ? distance : null;
}

export const CITY_OPTIONS = [
  { value: "279", label: "Makkah" },
  { value: "278", label: "Madinah" },
];

export const RATING_OPTIONS = [
  { value: "5", label: "5 Stars" },
  { value: "4", label: "4 Stars & up" },
  { value: "3", label: "3 Stars & up" },
  { value: "2", label: "2 Stars & up" },
  { value: "1", label: "1 Star & up" },
];

export const EMPTY_HOTEL_FILTERS = {
  cityId: "",
  rating: "",
  distanceMin: "",
  distanceMax: "",
};

export function emptyHotelFilters() {
  return { ...EMPTY_HOTEL_FILTERS };
}

export function countHotelFilters(filters = EMPTY_HOTEL_FILTERS) {
  let count = 0;
  if (filters.cityId) count += 1;
  if (filters.rating) count += 1;
  if (filters.distanceMin !== "" || filters.distanceMax !== "") count += 1;
  return count;
}

export function hotelMatchesFilters(hotel, filters = EMPTY_HOTEL_FILTERS) {
  if (filters.rating) {
    const stars = parseHotelStars(hotel);
    if (stars == null || stars < Number(filters.rating)) return false;
  }

  const distance = parseHotelDistance(hotel);
  if (filters.distanceMin !== "" && (distance == null || distance < Number(filters.distanceMin))) return false;
  if (filters.distanceMax !== "" && (distance == null || distance > Number(filters.distanceMax))) return false;

  return true;
}
